import type { AuthClientContextType } from "@shared/lib/authClient";
import { type QueryOptions, useQuery } from "@tanstack/react-query";

export function authQueryOptions(authClient: AuthClientContextType) {
	return {
		queryKey: ["auth"],
		queryFn: () => authClient.getSession()
	} satisfies QueryOptions;
}

export function useAuthQuery(authClient: AuthClientContextType) {
	return useQuery(authQueryOptions(authClient));
}
